import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { Icon } from "../../../../../atoms/icon";
import styles from "../../text-story-page/styles.m.css";
import stylePT from "./styles.m.css";

class Progressbar extends Component {
  constructor(props) {
    super(props);
    this.nextarticle = React.createRef();
  }
  toggleBox = () => {
    this.props.handleSetView();
    feedEvent(this.props, this.props.isOpened);
  };

  commentTriggerEvent = () => {
    const ID = get(this.props, ["story", "id"], () => null);
    this.props.handleVuukleCommentView(ID);
  };

  handleNextArticle = () => {
    this.props.handleSetView(true);
  };

  VuukleCommentView = () => {
    const ID = get(this.props, ["story", "id"], () => null);
    this.props.handleVuukleCommentView(ID);
  };

  render() {
    const props = this.props;
    const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
    const renderSocialMediaForMobile = get(props, ["renderSocialMediaForMobile"], () => null);
    const StoryId = get(props, ["story", "id"], () => null);
    const className = get(props, ["className"], () => null);
    const StoryUrl = get(props, ["story", "url"], () => null);
    // eslint-disable-next-line max-len
    const openAppUrl = `https://vikatanapp.page.link?link=${StoryUrl}&apn=com.vikatanapp&amv=54309&utm_source=web&utm_medium=articleopenapp`;
    let userAgent = "";
    if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
      userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
    }
    // eslint-disable-next-line no-useless-escape
    const scrollPercentage = this.props.scroll.split(/\.(?=[^\.]+$)/);
    return (
      <React.Fragment>
        <div className={`story-bottom ${className} readmore`} ref={this.nextarticle}>
          <div className={`${styles["comments"]}`}>
            {renderSocialMedia("show-desktop")}
            <a className={`${styles["comments_link"]}`} onClick={() => this.VuukleCommentView(StoryId)}>
              <Icon className="svg-comments" type="newsletter" />
            </a>
          </div>
          {renderSocialMediaForMobile({ commentTriggerEvent: this.commentTriggerEvent })}
          {this.props.isOpened === true ? (
            <a className="expandView" onClick={() => this.handleNextArticle()}>
              அடுத்த கட்டுரைக்கு
              <Icon type="arrow" />
            </a>
          ) : (
            <a onClick={() => this.toggleBox(StoryId)} className="expandView">
              மேலும் படிக்க
              <Icon type="arrow" />
            </a>
          )}
        </div>
        {this.props.isOpened === true && (
          <div className={`${stylePT["progress-app-wrapper"]}`}>
            {/android/i.test(userAgent) &&
              this.props.showMe && (
                <Link aria-label={`Open APP`} href={openAppUrl} className={`${stylePT["open-app"]} hidden-desktop`}>
                  <span className={`${stylePT["open-app-txt"]}`}>Open App</span>
                  <Icon type="phone" />
                </Link>
              )}
            <div className={`${stylePT["progress-wrapper"]}`}>
              <div
                className={`${stylePT["progress-bar"]}`}
                style={{ "--scroll": Number(scrollPercentage[1]) + Number(8) + "%" }}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

Progressbar.propTypes = {
  story: PropTypes.shape(),
  scroll: PropTypes.string,
  fireVirtualPageView: PropTypes.func,
  checkInfoStatus: PropTypes.func,
  handleSetView: PropTypes.func,
  handleVuukleCommentView: PropTypes.func,
  versionStat: PropTypes.string,
  isOpened: PropTypes.bool,
  index: PropTypes.number,
  showMe: PropTypes.bool
};

const feedEvent = (props, isOpened) => {
  if (!isOpened) {
    global.app.maybeSetUrl(
      "/" + props.story.slug + "?pfrom=" + props.versionStat,
      get(props, ["story", "seo", "meta-title"], props.story.headline)
    );

    props.fireVirtualPageView();
  }
  props.checkInfoStatus({ id: props.story.id, status: !isOpened });
};

export { Progressbar, feedEvent };
